import ZkCheckboxGroup from '../checkbox/src/checkbox-group.vue';

/* istanbul ignore next */
ZkCheckboxGroup.install = function(Vue) {
  Vue.component(ZkCheckboxGroup.name, ZkCheckboxGroup);
};

export default ZkCheckboxGroup;



// WEBPACK FOOTER //
// ./src/packages/checkbox-group/index.js